import storeFront from './client';
const apiType = 'sf';
const opts = {
    headers: {
        'Content-Type': `application/json`,
    },
};
export const getApi = async (endpoint, logger) => {
    logger ? storeFront.setLogger(logger) : undefined;
    return storeFront.get(endpoint, apiType);
};
export const postApi = async (body, endpoint, logger) => {
    logger ? storeFront.setLogger(logger) : undefined;
    return storeFront.post(endpoint, apiType, { data: body, headers: opts.headers });
};
export const putApi = async (body, endpoint, logger) => {
    logger ? storeFront.setLogger(logger) : undefined;
    return storeFront.put(endpoint, apiType, {
        data: body,
        headers: opts.headers,
    });
};
export const deleteApi = async (endpoint, logger) => {
    logger ? storeFront.setLogger(logger) : undefined;
    return storeFront.delete(endpoint, apiType);
};
